<div class="searchConsole specificationpage" id="searchConsoleDefult4" aria-hidden="true"
  aria-labelledby="searchConsoleDefultLabel4" tabindex="-1">
  <!-- [ngClass]="showBlock ? 'd-block' : 'd-none'" -->
  <div class="modal-dialog modal-dialog-centered modal-fullscreen">
    <div class="modal-content rounded-0 border-0">
      <button type="button" class="btn-close d-none" aria-label="Close" id="btnClose1"
        #btnClose></button>
      <app-advance-header [breadcrumb]="breadCrumb" (valueChange)='getChildValue($event)' class="head"></app-advance-header>
      <div class="modal-body d-flex justify-content-start align-items-start search-product-details py-4 px-5" style="height: 100vh;">
        <div class="col-12 col-sm-12 col-md-12 col-lg-10 col-xl-12 col-xxl-12 text-white h-100">
          <div class="row">
            <div class="col-12 col-sm-12 d-md-none pb-3 pt-3">
              <div class="prod-data">
                <div class="prod-content d-flex flex-column gap-2">
                  <div class="prod-name d-flex gap-2">
                    {{productDetailsData?.model}}
                    <!-- <div class="cta-action d-flex gap-2">
                      <div class="share-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_353_2790)">
                            <path
                              d="M13.12 17.0232L8.92096 14.7332C8.37276 15.3193 7.66095 15.7269 6.87803 15.9031C6.09512 16.0793 5.27731 16.0159 4.53088 15.7212C3.78445 15.4266 3.14392 14.9142 2.69253 14.2506C2.24114 13.5871 1.99976 12.8032 1.99976 12.0007C1.99976 11.1982 2.24114 10.4143 2.69253 9.75076C3.14392 9.08725 3.78445 8.57486 4.53088 8.28016C5.27731 7.98547 6.09512 7.92211 6.87803 8.09832C7.66095 8.27452 8.37276 8.68214 8.92096 9.2682L13.121 6.9782C12.8825 6.03428 12.9965 5.03579 13.4416 4.16991C13.8867 3.30402 14.6323 2.63018 15.5386 2.2747C16.445 1.91923 17.4499 1.90651 18.3649 2.23894C19.28 2.57137 20.0424 3.22612 20.5093 4.08046C20.9761 4.93481 21.1153 5.93009 20.9009 6.87975C20.6864 7.82941 20.1329 8.66824 19.3442 9.23901C18.5555 9.80979 17.5857 10.0733 16.6166 9.9802C15.6475 9.88708 14.7456 9.44371 14.08 8.7332L9.87996 11.0232C10.0412 11.6646 10.0412 12.3358 9.87996 12.9772L14.079 15.2672C14.7446 14.5567 15.6464 14.1133 16.6156 14.0202C17.5847 13.9271 18.5545 14.1906 19.3432 14.7614C20.1319 15.3322 20.6854 16.171 20.8999 17.1207C21.1143 18.0703 20.9751 19.0656 20.5083 19.9199C20.0414 20.7743 19.279 21.429 18.3639 21.7615C17.4489 22.0939 16.444 22.0812 15.5376 21.7257C14.6313 21.3702 13.8857 20.6964 13.4406 19.8305C12.9955 18.9646 12.8815 17.9661 13.12 17.0222V17.0232ZM5.99996 14.0002C6.5304 14.0002 7.0391 13.7895 7.41418 13.4144C7.78925 13.0393 7.99996 12.5306 7.99996 12.0002C7.99996 11.4698 7.78925 10.9611 7.41418 10.586C7.0391 10.2109 6.5304 10.0002 5.99996 10.0002C5.46953 10.0002 4.96082 10.2109 4.58575 10.586C4.21068 10.9611 3.99996 11.4698 3.99996 12.0002C3.99996 12.5306 4.21068 13.0393 4.58575 13.4144C4.96082 13.7895 5.46953 14.0002 5.99996 14.0002ZM17 8.0002C17.5304 8.0002 18.0391 7.78949 18.4142 7.41442C18.7892 7.03934 19 6.53064 19 6.0002C19 5.46977 18.7892 4.96106 18.4142 4.58599C18.0391 4.21092 17.5304 4.0002 17 4.0002C16.4695 4.0002 15.9608 4.21092 15.5857 4.58599C15.2107 4.96106 15 5.46977 15 6.0002C15 6.53064 15.2107 7.03934 15.5857 7.41442C15.9608 7.78949 16.4695 8.0002 17 8.0002ZM17 20.0002C17.5304 20.0002 18.0391 19.7895 18.4142 19.4144C18.7892 19.0393 19 18.5306 19 18.0002C19 17.4698 18.7892 16.9611 18.4142 16.586C18.0391 16.2109 17.5304 16.0002 17 16.0002C16.4695 16.0002 15.9608 16.2109 15.5857 16.586C15.2107 16.9611 15 17.4698 15 18.0002C15 18.5306 15.2107 19.0393 15.5857 19.4144C15.9608 19.7895 16.4695 20.0002 17 20.0002Z"
                              fill="#9D9DBF" />
                          </g>
                          <defs>
                            <clipPath id="clip0_353_2790">
                              <rect width="24" height="24" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <div class="wishlist-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_353_2791)">
                            <path
                              d="M12.001 4.52898C14.35 2.41998 17.98 2.48998 20.243 4.75698C22.505 7.02498 22.583 10.637 20.479 12.993L11.999 21.485L3.52101 12.993C1.41701 10.637 1.49601 7.01898 3.75701 4.75698C6.02201 2.49298 9.64501 2.41698 12.001 4.52898ZM18.827 6.16998C17.327 4.66798 14.907 4.60698 13.337 6.01698L12.002 7.21498L10.666 6.01798C9.09101 4.60598 6.67601 4.66798 5.17201 6.17198C3.68201 7.66198 3.60701 10.047 4.98001 11.623L12 18.654L19.02 11.624C20.394 10.047 20.319 7.66498 18.827 6.16998Z"
                              fill="#9D9DBF" />
                          </g>
                          <defs>
                            <clipPath id="clip0_353_2791">
                              <rect width="24" height="24" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                    </div> -->
                  </div>
                  <div class="prod-price">
                    {{productDetailsData?.price_range | currency:'INR':'symbol':'4.0-0'}} <span>Ex-showroom Price</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3 order-md-1 order-2 pt-3 pt-md-0">
              <div class="prod-data d-none d-md-block">
                <div class="prod-content d-flex flex-column gap-2">
                  <div class="prod-name d-flex gap-2">
                    {{productDetailsData?.model}}
                    <!-- <div class="cta-action d-flex gap-2">
                      <div class="share-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_353_2790)">
                            <path
                              d="M13.12 17.0232L8.92096 14.7332C8.37276 15.3193 7.66095 15.7269 6.87803 15.9031C6.09512 16.0793 5.27731 16.0159 4.53088 15.7212C3.78445 15.4266 3.14392 14.9142 2.69253 14.2506C2.24114 13.5871 1.99976 12.8032 1.99976 12.0007C1.99976 11.1982 2.24114 10.4143 2.69253 9.75076C3.14392 9.08725 3.78445 8.57486 4.53088 8.28016C5.27731 7.98547 6.09512 7.92211 6.87803 8.09832C7.66095 8.27452 8.37276 8.68214 8.92096 9.2682L13.121 6.9782C12.8825 6.03428 12.9965 5.03579 13.4416 4.16991C13.8867 3.30402 14.6323 2.63018 15.5386 2.2747C16.445 1.91923 17.4499 1.90651 18.3649 2.23894C19.28 2.57137 20.0424 3.22612 20.5093 4.08046C20.9761 4.93481 21.1153 5.93009 20.9009 6.87975C20.6864 7.82941 20.1329 8.66824 19.3442 9.23901C18.5555 9.80979 17.5857 10.0733 16.6166 9.9802C15.6475 9.88708 14.7456 9.44371 14.08 8.7332L9.87996 11.0232C10.0412 11.6646 10.0412 12.3358 9.87996 12.9772L14.079 15.2672C14.7446 14.5567 15.6464 14.1133 16.6156 14.0202C17.5847 13.9271 18.5545 14.1906 19.3432 14.7614C20.1319 15.3322 20.6854 16.171 20.8999 17.1207C21.1143 18.0703 20.9751 19.0656 20.5083 19.9199C20.0414 20.7743 19.279 21.429 18.3639 21.7615C17.4489 22.0939 16.444 22.0812 15.5376 21.7257C14.6313 21.3702 13.8857 20.6964 13.4406 19.8305C12.9955 18.9646 12.8815 17.9661 13.12 17.0222V17.0232ZM5.99996 14.0002C6.5304 14.0002 7.0391 13.7895 7.41418 13.4144C7.78925 13.0393 7.99996 12.5306 7.99996 12.0002C7.99996 11.4698 7.78925 10.9611 7.41418 10.586C7.0391 10.2109 6.5304 10.0002 5.99996 10.0002C5.46953 10.0002 4.96082 10.2109 4.58575 10.586C4.21068 10.9611 3.99996 11.4698 3.99996 12.0002C3.99996 12.5306 4.21068 13.0393 4.58575 13.4144C4.96082 13.7895 5.46953 14.0002 5.99996 14.0002ZM17 8.0002C17.5304 8.0002 18.0391 7.78949 18.4142 7.41442C18.7892 7.03934 19 6.53064 19 6.0002C19 5.46977 18.7892 4.96106 18.4142 4.58599C18.0391 4.21092 17.5304 4.0002 17 4.0002C16.4695 4.0002 15.9608 4.21092 15.5857 4.58599C15.2107 4.96106 15 5.46977 15 6.0002C15 6.53064 15.2107 7.03934 15.5857 7.41442C15.9608 7.78949 16.4695 8.0002 17 8.0002ZM17 20.0002C17.5304 20.0002 18.0391 19.7895 18.4142 19.4144C18.7892 19.0393 19 18.5306 19 18.0002C19 17.4698 18.7892 16.9611 18.4142 16.586C18.0391 16.2109 17.5304 16.0002 17 16.0002C16.4695 16.0002 15.9608 16.2109 15.5857 16.586C15.2107 16.9611 15 17.4698 15 18.0002C15 18.5306 15.2107 19.0393 15.5857 19.4144C15.9608 19.7895 16.4695 20.0002 17 20.0002Z"
                              fill="#9D9DBF" />
                          </g>
                          <defs>
                            <clipPath id="clip0_353_2790">
                              <rect width="24" height="24" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <div class="wishlist-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_353_2791)">
                            <path
                              d="M12.001 4.52898C14.35 2.41998 17.98 2.48998 20.243 4.75698C22.505 7.02498 22.583 10.637 20.479 12.993L11.999 21.485L3.52101 12.993C1.41701 10.637 1.49601 7.01898 3.75701 4.75698C6.02201 2.49298 9.64501 2.41698 12.001 4.52898ZM18.827 6.16998C17.327 4.66798 14.907 4.60698 13.337 6.01698L12.002 7.21498L10.666 6.01798C9.09101 4.60598 6.67601 4.66798 5.17201 6.17198C3.68201 7.66198 3.60701 10.047 4.98001 11.623L12 18.654L19.02 11.624C20.394 10.047 20.319 7.66498 18.827 6.16998Z"
                              fill="#9D9DBF" />
                          </g>
                          <defs>
                            <clipPath id="clip0_353_2791">
                              <rect width="24" height="24" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                    </div> -->
                  </div>
                  <div class="prod-price">
                    {{productDetailsData?.price_range | currency:'INR':'symbol':'4.0-0'}} <span>Ex-showroom Price</span>
                  </div>
                </div>
              </div>
              <div class="specification mt-4">
                <h5>Specifications</h5>
                <div class="spec-box">
                  <div class="spec-item d-flex gap-3">
                    <div class="spec-img">
                      <img [src]='environment1 + "assets/images/advancesearch/icon_Payload_capacity.png"' loading="lazy"
                        class="img-fluid" alt="icon_Payload_capacity" />
                    </div>
                    <div class="spec-content">
                      <div class="spec-content-title">GVW</div>
                      <div class="spec-desc">{{productDetailsData?.gvw
                        }}</div>
                    </div>
                  </div>
                  <div class="spec-item d-flex gap-3">
                    <div class="spec-img">
                      <img [src]='environment1 + "assets/images/advancesearch/icon_Power.png"' loading="lazy"
                        class="img-fluid" alt="icon_Payload_capacity" />
                    </div>
                    <div class="spec-content">
                      <div class="spec-content-title">Power</div>
                      <div class="spec-desc">{{productDetailsData?.max_power}}</div>
                    </div>
                  </div>
                  <div class="spec-item d-flex gap-3">
                    <div class="spec-img">
                      <img [src]='environment1 + "assets/images/advancesearch/icon_Torque.png"' class="img-fluid"
                        alt="icon_Payload_capacity" loading="lazy" />
                    </div>
                    <div class="spec-content">
                      <div class="spec-content-title">Torque</div>
                      <div class="spec-desc">{{productDetailsData?.max_torque}}</div>
                    </div>
                  </div>
                  <div class="spec-item d-flex gap-3">
                    <div class="spec-img">
                      <img [src]='environment1 + "assets/images/advancesearch/Tyre.png"' class="img-fluid"
                        alt="icon_Payload_capacity" loading="lazy" />
                    </div>
                    <div class="spec-content">
                      <div class="spec-content-title">Tyres</div>
                      <div class="spec-desc">{{productDetailsData?.front_tyre + ',' + productDetailsData?.rear_tyre}}
                      </div>
                    </div>
                  </div>
                  <div class="spec-item d-flex gap-3">
                    <div class="spec-img">
                      <img [src]='environment1 + "assets/images/advancesearch/icon_Warranty.png"' class="img-fluid"
                        alt="icon_Payload_capacity" loading="lazy" />
                    </div>
                    <div class="spec-content">
                      <div class="spec-content-title">Warranty</div>
                      <div class="spec-desc">{{productDetailsData?.warranty}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 mx-auto middle-sec order-md-2 order-1">
                <div class="middle-img">
                  <img src="{{ level3newImages?.l3_actual_name == 'Maxi Van passenger' || level3newImages?.l3_actual_name == 'Maxi Van-Ambulance' || level3newImages?.l3_actual_name == 'Mini Van' ||  level3newImages?.l3_actual_name == 'ICV Buses school' || level3newImages?.l3_actual_name == 'LCV Buses school' ? level3newImages?.l3_image_path: level3DataImages }}" class="img-fluid main-img" alt="truck-reflection" />
                  <div class="ellipse"></div>
                  <img src="{{level3newImages?.l3_actual_name == 'Maxi Van passenger' || level3newImages?.l3_actual_name == 'Maxi Van-Ambulance' || level3newImages?.l3_actual_name == 'Mini Van' ||  level3newImages?.l3_actual_name == 'ICV Buses school' || level3newImages?.l3_actual_name == 'LCV Buses school' ? level3newImages?.l3_image_path: level3DataImages }}" class="img-fluid img-mirror" alt="truck-reflection" />
                </div>

                <div class="product-action">
                  <div class="img-box d-flex gap-3">
                    <div class="thumbnail-item" *ngIf="productDetailsData?.images?.length>1">
                      <img src="{{productDetailsData?.images[1]?.image_url}}" class="img-fluid" alt="truck" />
                    </div>
                    <div class="thumbnail-item" *ngIf="productDetailsData?.images?.length>2">
                      <img src="{{productDetailsData?.images[2]?.image_url}}" class="img-fluid" alt="truck" />
                    </div>
                    <div class="thumbnail-item " *ngIf="productDetailsData?.images?.length>3">
                      <img src="{{productDetailsData?.images[3]?.image_url}}" class="img-fluid" alt="truck" />
                      <div class="overlay">
                        <!-- <div>2 more</div> -->
                      </div>
                    </div>
                  </div>
                  <div class="cta-action d-grid d-sm-flex gap-3 mt-4 justify-content-center">
                    <button type="button" class="btn btn-primary btn-grad-primary btn-sm" (click)="bookNow()">
                      Enquire Now
                    </button>
                    <button type="button" class="btn btn-primary btn-white btn-sm" data-bs-target="#searchConsoleDefult5"
                       (click)="getSmartFilterData()">
                      Smart Select
                    </button>
                    <button type="button" class="btn btn-primary btn-white btn-sm d-none">
                      Book Test Drive
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-3 col-xxl-3 order-3 order-md-3 right-side-cont">
                <div class="rtl-side  gap-4">
                  <div class="row g-3">
                    <div class="col-6 col-sm-6 col-md-12 col-lg-12 col-xl-12">
                      <div class="monthly-emi">
                        <div>
                          Monthly EMI
                          <img [src]='environment1 + "assets/images/advancesearch/information-line.png"' loading="lazy" (mouseover)="toggleTooltip()" (mouseout)="toggleTooltip()"
                            class="img-fluid" alt="information-line" />
                            <div class="ms-3" *ngIf="tooltipOpen" style="border: 1px solid white;padding: 7px;position: absolute;display: inline;border-radius: 9px;">
                              <span style="font-size: 12px;">Total Cost :{{productDetailsData?.price_range | currency:'INR':'symbol':'4.0-0'}} </span> <br>
                              <span style="font-size: 12px;">IRR : 15 % </span> <br>
                              <span style="font-size: 12px;">Tenure : 5 Years</span> <br>
                            </div>
                          </div>
                        <div class="monthly-price">{{ result.emi }}</div>
                      </div>
                    </div>
                    <div class=" col-6 col-sm-6 col-md-12 col-lg-12 col-xl-12 business-return second-modal-panel" *ngIf="isBrtLinkVisible">
                      <div>
                        Business Returns
                        <!-- <img [src]='environment1 + "assets/images/advancesearch/information-line.png"' loading="lazy"
                          class="img-fluid" alt="information-line"  /> -->
                        <!-- <button  style="background: black;"> -->

                        <img [src]='environment1 + "assets/images/advancesearch/information-line.png"' loading="lazy"  (mouseover)="toggleTooltipBrtpop()" (mouseout)="toggleTooltipBrtpop()"
                          class="img-fluid" alt="information-line" style="cursor: pointer;" />
                          <div class="ms-3" *ngIf="tooltipOpenBrt && brtEstimateTotalEarning_1year == undefined" style="border: 1px solid white;padding: 4px;position: absolute;display: inline;">
                            <!-- <span style="font-size: 12px;">Emi :{{result.emi}}  Interest: {{result.interest}} Total:  {{result.total}}</span> -->
                             <span style="font-size: 12px;">Click here to calculate Estimated Profit</span>
                          </div>
                          <div class="ms-3" *ngIf="tooltipOpenBrt && brtEstimateTotalEarning_1year" style="border: 1px solid white;padding: 4px;position: absolute;display: inline;">
                            <!-- <span style="font-size: 12px;">Emi :{{result.emi}}  Interest: {{result.interest}} Total:  {{result.total}}</span> -->
                             <span style="font-size: 12px;">{{ brtEstimateTotalEarning_1year ? (brtEstimateTotalEarning_1year | currency:'INR':'symbol':'4.0-0') : '' }}</span>
                          </div>
                        <!-- </button> -->
                      </div>
                      <p style="color: #307fe2;font-size: 14px;cursor: pointer;"  data-bs-target="#searchConsoleDefult123"
                      (click)="openBrtCalculator()"   *ngIf="isBrtLinkVisible">Click here to calculate Estimated Profit</p>
                      <div class="business-r-price">
                        {{ brtEstimateTotalEarning_1year ? (brtEstimateTotalEarning_1year | currency:'INR':'symbol':'4.0-0') : '' }}
                      </div>
                  </div>
                    <div class="col-12 col-sm-12 col-xs-12 col-md-12 col-lg-12 col-xl-12 ">

                    <div class="modal fade searchConsole brt" id="searchConsoleDefult123" aria-hidden="true"
                    aria-labelledby="searchConsoleDefultLabelbrt" tabindex="-1">
                    <div class="modal-dialog modal-dialog-centered">
                      <div class="modal-content rounded-0 border-0 main-screen globalSearch-bg">
                        <div class="modal-body" style="background: aliceblue;">
                          <div class="row conf-brt-outer-box">
                            <div class="d-flex justify-content-between conf-brt-calculator-title">
                              <p>BRT Calculator</p>
                              <div class="conf-knowmore-close-icon d-flex justify-content-center align-items-center"
                                mat-dialog-close>
                                <button id="myModal" type="button" class="btn-close" 
                                  id="btnclosebrt" #btnclose aria-label="Close" (click)="closeall()">
                                  <!-- <img src="{{confAWSUrlStr}}/common/conf-cancel-icon.svg"> -->
                                </button>
                              </div>
                            </div>

                            <form #brtForm="ngForm" (ngSubmit)="getData(brtForm.value);brtForm.resetForm()">

                              <div class="ng-for ng-for-form "
                                *ngFor="let item of BRT_FORM_FIELDS; let index = index;"
                                [ngClass]="{'conf-brt-invalid-field': item.isValid === false}">

                                <!-- IF TYPE === INPUT -->
                                <div *ngIf="item.type === 'input' && item.hide === false" class="mt-3">
                                  <div class="conf-brt-form-label d-flex conf-brt-tooltip">
                                    <p>{{item.label}}</p>
                                    <div *ngIf="item.tooltip.enable" class="conf-tooltip"><img
                                        src="{{confAWSUrlStr}}/common/conf-brt-info-icon.svg" alt="image-disclaimer">
                                      <p class="conf-tooltiptext">{{item.tooltip.content}}</p>
                                    </div>
                                  </div>
                                  <div class="conf-brt-form-input d-flex justify-content-between align-items-center">
                                    <input type="text"
                                      onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                                      id="val_{{index}}" ngModel name="{{item.label}}" placeholder="Enter here" />
                                    <span>{{item.unit}}</span>
                                  </div>
                                </div>

                                <!-- IF TYPE === INPUT_DECIMAL -->
                                <div *ngIf="item.type === 'input_decimal' && item.hide === false" class="mt-3">
                                  <div class="conf-brt-form-label d-flex conf-brt-tooltip">
                                    <p>{{item.label}}</p>
                                    <div *ngIf="item.tooltip.enable" class="conf-tooltip"><img
                                        src="{{confAWSUrlStr}}/common/conf-brt-info-icon.svg" alt="image-disclaimer">
                                      <p class="conf-tooltiptext">{{item.tooltip.content}}</p>
                                    </div>
                                  </div>
                                  <div class="conf-brt-form-input d-flex justify-content-between align-items-center">
                                    <input type="text" (keydown)="validateNumber($event)" id="val_{{index}}" ngModel
                                      name="{{item.label}}" placeholder="Enter here" />
                                    <span>{{item.unit}}</span>
                                  </div>
                                </div>

                                <!-- IF TYPE === RANGE -->
                                <div class="mt-4" *ngIf="item.type === 'range' && item.hide === false">

                                  <div
                                    class="conf-brt-range-label-value d-flex justify-content-between align-items-center align-self-center">
                                    <div class="conf-brt-form-label d-flex conf-brt-tooltip">
                                      <p>{{item.label}} </p>
                                      <div *ngIf="item.tooltip.enable" class="conf-tooltip"><img
                                          src="{{confAWSUrlStr}}/common/conf-brt-info-icon.svg"
                                          alt="image-disclaimer">
                                        <p class="conf-tooltiptext">{{item.tooltip.content}}</p>
                                      </div>
                                    </div>
                                    <div
                                      class="conf-brt-range-value-box d-flex justify-content-between align-items-center align-self-center">
                                      <div
                                        class="conf-brt-range-value-box-value align-items-center conf-brt-form-input__  align-self-center">
                                        <input type="text"
                                          onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                                          value="{{item.value}}" id="_input_{{index}}"
                                          (keyup)='onFocus(item.label,$event)'
                                          (focusout)='onFocusout(item.label,$event)' />
                                      </div>
                                      <div
                                        class="conf-brt-range-value-box-unit align-items-center  align-self-center">
                                        <span>{{item.unit}}</span>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="range meter mt-1">
                                    <div class="conf-slider-container">

                                      <div class="conf-slider-title" *ngIf="item.label !== 'Finance Charge(IRR)'">
                                        <div
                                          class="conf-nof-title d-xl-flex d-lg-flex d-md-flex justify-content-start"
                                          *ngFor="let item1 of range_Array; let index = index">
                                          <div class="align-self-start">
                                            <p *ngIf="index === 0 || index === (range_Array?.length-1)">{{ item1 }}</p>
                                          </div>
                                        </div>
                                      </div>

                                      <div class="conf-slider-title" *ngIf="item.label === 'Finance Charge(IRR)'">
                                        <div
                                          class="conf-nof-title d-xl-flex d-lg-flex d-md-flex justify-content-start"
                                          *ngFor="let item1 of range_Array_special; let index = index">
                                          <div class="align-self-start">
                                            <p *ngIf="index === 0 || index === (range_Array_special?.length-1)">{{
                                              item1
                                              }}</p>
                                          </div>
                                        </div>
                                      </div>

                                      <!-- [ngStyle]="{'background' : 'linear-gradient(to right, #307fe2 '+range_of_value+'%, #E3EDF7 0%)'}" -->
                                      <!-- [ngStyle]="{'background' : 'linear-gradient(to right, #307fe2 '+(gvwRangeSlider-1)/(max-1)*100+'%, #E3EDF7 0%)'}" -->


                                      <div class="conf_scroll_container" *ngIf="item.label !== 'Finance Charge(IRR)'">
                                        <input type="range" name="range" id="range" min="0" max="100" step="1" value="{{item.value}}" (input)="processData($event,item.label)" (change)="processData($event,item.label)" />
                                        <div class="_scale_" [ngStyle]="{'background' : 'linear-gradient(to right, #307fe2 '+(item.value-1)/(100)*100+'%, #E3EDF7 0%)'}">
                                            <div class="_scale_cm" *ngFor="let x of [].constructor((range_Array?.length-1)); let i = index;" [ngStyle]="{'width':''+(100/(range_Array?.length-1))+'%'}">
                                                <div class="_scale_mm none__"></div>
                                                <div class="_scale_mm"></div>
                                                <div class="_scale_mm"></div>
                                                <div class="_scale_mm"></div>
                                                <div class="_scale_mm"></div>
                                            </div>
                                        </div>
                                      </div>

                                      <div class="conf_scroll_container" *ngIf="item.label === 'Finance Charge(IRR)'">
                                        <input type="range" name="range" id="range" min="0" max="20" step="1" value="{{item.value}}" (input)="processData($event,item.label)" (change)="processData($event,item.label)" />
                                        <div class="_scale_" [ngStyle]="{'background' : 'linear-gradient(to right, #307fe2 '+(item.value)/(20)*100+'%, #E3EDF7 0%)'}">
                                            <div class="_scale_cm" *ngFor="let x of [].constructor((range_Array_special?.length-1)); let i = index;" [ngStyle]="{'width':''+(100/(range_Array_special?.length-1))+'%'}">
                                                <div class="_scale_mm none__"></div>
                                                <div class="_scale_mm"></div>
                                                <div class="_scale_mm"></div>
                                                <div class="_scale_mm"></div>
                                                <div class="_scale_mm"></div>
                                            </div>
                                        </div>
                                      </div>

                                    </div>
                                  </div>
                                </div>

                                <!-- IF TYPE === RANGE_DECIMAL -->
                                <div class="mt-4" *ngIf="item.type === 'range_decimal' && item.hide === false">

                                  <div
                                    class="conf-brt-range-label-value d-flex justify-content-between align-items-center align-self-center">
                                    <div class="conf-brt-form-label d-flex conf-brt-tooltip">
                                      <p>{{item.label}} </p>
                                      <div *ngIf="item.tooltip.enable" class="conf-tooltip"><img
                                          src="{{confAWSUrlStr}}/common/conf-brt-info-icon.svg"
                                          alt="image-disclaimer">
                                        <p class="conf-tooltiptext">{{item.tooltip.content}}</p>
                                      </div>
                                    </div>
                                    <div
                                      class="conf-brt-range-value-box d-flex justify-content-between align-items-center align-self-center">
                                      <div
                                        class="conf-brt-range-value-box-value align-items-center conf-brt-form-input__  align-self-center">
                                        <input type="text" value="{{item.value}}" id="_input_{{index}}"
                                          (keydown)="validateNumber($event)" (keyup)='onFocus(item.label,$event)'
                                          (focusout)='onFocusout(item.label,$event)' />
                                      </div>
                                      <div
                                        class="conf-brt-range-value-box-unit align-items-center  align-self-center">
                                        <span>{{item.unit}}</span>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="range meter mt-1">
                                    <div class="conf-slider-container">

                                      <div class="conf-slider-title" *ngIf="item.label !== 'Finance Charge(IRR)'">
                                        <div
                                          class="conf-nof-title d-xl-flex d-lg-flex d-md-flex justify-content-start"
                                          *ngFor="let item1 of range_Array; let index = index">
                                          <div class="align-self-start">
                                            <p *ngIf="index === 0 || index === (range_Array?.length-1)">{{ item1 }}</p>
                                          </div>
                                        </div>
                                      </div>

                                      <div class="conf-slider-title" *ngIf="item.label === 'Finance Charge(IRR)'">
                                        <div
                                          class="conf-nof-title d-xl-flex d-lg-flex d-md-flex justify-content-start"
                                          *ngFor="let item1 of range_Array_special; let index = index">
                                          <div class="align-self-start">
                                            <p *ngIf="index === 0 || index === (range_Array_special?.length-1)">{{
                                              item1
                                              }}</p>
                                          </div>
                                        </div>
                                      </div>

                                      <!-- [ngStyle]="{'background' : 'linear-gradient(to right, #307fe2 '+range_of_value+'%, #E3EDF7 0%)'}" -->
                                      <!-- [ngStyle]="{'background' : 'linear-gradient(to right, #307fe2 '+(gvwRangeSlider-1)/(max-1)*100+'%, #E3EDF7 0%)'}" -->

                                      <div class="conf_scroll_container" *ngIf="item.label !== 'Finance Charge(IRR)'">
                                        <input type="range" name="range" id="range" min="0" max="100" step="1"
                                          value="{{item.value}}" (input)="processData($event,item.label)"
                                          (change)="processData($event,item.label)" />
                                        <div class="_scale_"
                                          [ngStyle]="{'background' : 'linear-gradient(to right, #307fe2 '+(item.value-1)/(100)*100+'%, #E3EDF7 0%)'}">
                                          <div class="_scale_cm"
                                            *ngFor="let x of [].constructor((range_Array?.length-1)); let i = index;"
                                            [ngStyle]="{'width':''+(100/(range_Array?.length-1))+'%'}">
                                            <div class="_scale_mm none__"></div>
                                            <div class="_scale_mm"></div>
                                            <div class="_scale_mm"></div>
                                            <div class="_scale_mm"></div>
                                            <div class="_scale_mm"></div>
                                          </div>
                                        </div>
                                      </div>

                                      <div class="conf_scroll_container" *ngIf="item.label === 'Finance Charge(IRR)'">
                                        <input type="range" name="range" id="range" min="0" max="20" step="1"
                                          value="{{item.value}}" (input)="processData($event,item.label)"
                                          (change)="processData($event,item.label)" />
                                        <div class="_scale_"
                                          [ngStyle]="{'background' : 'linear-gradient(to right, #307fe2 '+(item.value)/(20)*100+'%, #E3EDF7 0%)'}">
                                          <div class="_scale_cm"
                                            *ngFor="let x of [].constructor((range_Array_special?.length-1)); let i = index;"
                                            [ngStyle]="{'width':''+(100/(range_Array_special?.length-1))+'%'}">
                                            <div class="_scale_mm none__"></div>
                                            <div class="_scale_mm"></div>
                                            <div class="_scale_mm"></div>
                                            <div class="_scale_mm"></div>
                                            <div class="_scale_mm"></div>
                                          </div>
                                        </div>
                                      </div>

                                    </div>
                                  </div>
                                </div>

                                <!-- IF TYPE === DROPDOWN -->
                                <div class="ng-if type == dropdown mt-4"
                                  *ngIf="item.type === 'dropdown' && item.hide === false">
                                  <div class="conf-brt-form-label d-flex conf-brt-tooltip">
                                    <p>
                                      {{item.label}}
                                    </p>
                                    <div *ngIf="item.tooltip.enable" class="conf-tooltip"><img
                                        src="{{confAWSUrlStr}}/common/conf-brt-info-icon.svg" alt="image-disclaimer">
                                      <p class="conf-tooltiptext">{{item.tooltip.content}}</p>
                                    </div>
                                  </div>
                                  <div class="conf-wrapper">
                                    <div class="conf-select-menu-tax-mode mt-2"
                                      [ngClass]="isTenureDropDownClicked === true ? 'conf-active' : ''"
                                      [ngClass]="selectedTenure !== undefined ? 'conf-select-menu-tax-mode-selected' : '' "
                                      (click)="onTenureDropDownClickHandler()">
                                      <div class="conf-select-btn-tax-mode d-flex justify-content-between"
                                        [ngClass]="selectedTenure !== undefined ? 'conf-select-menu-tax-mode-selected' : '' ">
                                        <span class="conf-sBtn-text-tax-mode">{{selectedTenure === undefined ?
                                          'Select'
                                          : selectedTenure}}</span>
                                        <!-- <i class="bx bx-chevron-down"></i> -->
                                        <img class="conf-dropdown-icon" src="{{confAWSUrlStr}}/common/arrow-down.svg">
                                      </div>
                                      <ul class="conf-options-tax-mode">
                                        <li class="conf-option-tax-mode" *ngFor="let item_ of tenureInMonths;"
                                          (click)="onTenureSelected(item_, item.label)">
                                          <span class="conf-option-text-tax-mode">{{item_}}</span>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>

                                <!-- IF TYPE === METER -->
                                <div class="ng-if type == meter mt-4"
                                  *ngIf="item.type === 'meter' && item.hide === false">

                                  <div
                                    class="conf-brt-range-label-value d-flex justify-content-between align-items-center align-self-center">
                                    <div class="conf-brt-form-label d-flex conf-brt-tooltip">
                                      <p>{{item.label}}</p>
                                      <div *ngIf="item.tooltip.enable" class="conf-tooltip"><img
                                          src="{{confAWSUrlStr}}/common/conf-brt-info-icon.svg"
                                          alt="image-disclaimer">
                                        <p class="conf-tooltiptext">{{item.tooltip.content}}</p>
                                      </div>
                                    </div>
                                    <div
                                      class="conf-brt-range-value-box d-flex justify-content-between align-items-center align-self-center">
                                      <div
                                        class="conf-brt-range-value-box-value align-items-center conf-brt-form-input__  align-self-center">
                                        <input type="text"
                                          onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                                          value="{{item.value}}" id="_input_{{index}}"
                                          (keyup)='onFocus_meter(item.label,$event)'
                                          (focusout)='onFocusout(item.label,$event)' />
                                      </div>
                                      <div
                                        class="conf-brt-range-value-box-unit align-items-center  align-self-center">
                                        <span>{{item.unit}}</span>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="conf-annual-kms mt-3 d-flex justify-content-center align-items-center">
                                    <div class="conf-annual-kms-down-btn"
                                      (click)="annualKmPrevClick(selectedAnnualKms, item.label)">
                                      <img src="{{confAWSUrlStr}}/common/conf-arrow-icon-down.svg">
                                    </div>
                                    <div class="conf-annual-kms-meter d-flex justify-content-center">
                                      <div
                                        class="conf-annual-kms-value d-flex justify-content-center align-self-center"
                                        *ngFor="let count of selectedAnnualKms; let index = index">
                                        <p>{{count}}</p>
                                      </div>
                                      <div
                                        class="conf-annual-kms-value d-flex justify-content-center align-self-center">
                                        <p>K</p>
                                      </div>
                                      <div
                                        class="conf-annual-kms-value d-flex justify-content-center align-self-center">
                                        <p>m</p>
                                      </div>
                                      <div
                                        class="conf-annual-kms-value d-flex justify-content-center align-self-center">
                                        <p>s</p>
                                      </div>
                                    </div>
                                    <div class="conf-annual-kms-up-btn"
                                      (click)="annualKmNextClick(selectedAnnualKms, item.label)">
                                      <img src="{{confAWSUrlStr}}/common/conf-arrow-icon-up.svg">
                                    </div>
                                  </div>

                                </div>


                              </div>
                              <div *ngIf="ErrorMsg" class="conf-brt-error-msg">
                                *Please Fill the mandatory fields.
                              </div>

                              <div class="ng-for mt-3 conf-process-data">
                                <div class="conf-button-container">
                                  <button class="conf_button_no"  aria-label="Close"
                                    (click)="closeall()">No</button>
                                  <button class="conf_button_submit"
                                    (click)="dataofcalculatedamount()">Submit</button>
                                </div>
                              </div>
                            </form>

                          </div>



                          <!-- <div class="col-12 col-sm-12 col-md-12 col-lg-10 col-xl-8 col-xxl-7 text-white text-center">
                          <div class="header-content d-grid gap-2">
                            <div class="ad-se-fp-logo-text">
                              Welcome to
                              <span class="d-block ">Tata Motors Fleet Verse</span>
                            </div>
                            <div class="ad-se-fp-logo-title mt-3">
                              Search the commercial vehicle you are looking for
                            </div>
                          </div>
                          <div class="input-search mt-5">

                            <input type="text" class="form-control" placeholder="Type Tata trucks" #searchInput />


                            <div class="select-asset">

                            </div>
                          </div>
                          <div class="d-sm-block mt-4">
                            <button id="searchBtn" #searchBtn type="button" class="btn btn-primary btn-grad-primary"
                              data-bs-target="#searchConsoleDefult2"  (click)="getSmartSearch(searchInput.value)">
                              Search
                            </button>
                          </div>
                        </div> -->
                        </div>
                      </div>
                    </div>
                  </div>



                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                      <div class="top-features" *ngIf="featureList?.length>0">
                        <div class="title-features">Top Features</div>
                        <div class="mb-3">
                          <div class="accordion" id="accordionTopFeature">
                            <div class="accordion-item" *ngFor="let item of featureList;let id = index">
                              <div class="accordion-header" id="featureOne">
                                <div class="accordion-button" type="button" data-bs-toggle="collapse"
                                  [attr.data-bs-target]="'#collapseOne' + id" aria-expanded="true"
                                  aria-controls="collapseOne">
                                  <div class="heading-content">
                                    <div class="heading-text">{{item?.description}}</div>
                                  </div>
                                </div>
                              </div>
                              <div id="collapseOne{{id}}" class="accordion-collapse collapse " [class.show]="id === 0"
                                aria-labelledby="featureOne" data-bs-parent="#accordionTopFeature">
                                <div class="accordion-body">
                                  <img [src]="item?.image_path" class="img-fluid" alt="prod-item" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>

                  </div>



                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div *ngIf="smartFilter?.length>0">
<app-advance-filter [smartFilter]="smartFilter" [level3DataImages]="level3DataImages" [breadCrumb]="breadCrumb" [json]="json" [productDetailsData]="productDetailsData"></app-advance-filter>
  </div> -->

